import React, { FC } from "react";
import Image from "next/image";
import styles from "./CampaignPartners.module.scss";


import Image0 from "@cs/public/img/olympiad/partners/Bow20Seat_Logo.png";
import Image1 from "@cs/public/img/olympiad/partners/Building_U.png";
import Image2 from "@cs/public/img/olympiad/partners/CCH.png";
import Image3 from "@cs/public/img/olympiad/partners/CSAYN.png";
import Image4 from "@cs/public/img/olympiad/partners/ChemEnggAssoIITKGP.png";
import Image5
  from "@cs/public/img/olympiad/partners/Chloride_Free_Foundation.png";
import Image6 from "@cs/public/img/olympiad/partners/ClimateFrontIndia.png";
import Image7 from "@cs/public/img/olympiad/partners/Climate_Operation_.png";
import Image8 from "@cs/public/img/olympiad/partners/DofE_International.png";
import Image9 from "@cs/public/img/olympiad/partners/DofE_New_Zealand.png";
import Image10 from "@cs/public/img/olympiad/partners/DofE_Romania.png";
import Image11 from "@cs/public/img/olympiad/partners/Earth_Minutes.png";
import Image12
  from "@cs/public/img/olympiad/partners/EcoSavioursAssociation.png";
import Image13 from "@cs/public/img/olympiad/partners/Eco_Network.png";
import Image14 from "@cs/public/img/olympiad/partners/Eco_Schools.png";
import Image15 from "@cs/public/img/olympiad/partners/EmpoderaClima.png";
import Image16 from "@cs/public/img/olympiad/partners/FFFNigeria.png";
import Image17 from "@cs/public/img/olympiad/partners/FFF_Argentina_.png";
import Image18 from "@cs/public/img/olympiad/partners/FFF_Cz_.png";
import Image19 from "@cs/public/img/olympiad/partners/FFF_Greece_.png";
import Image20 from "@cs/public/img/olympiad/partners/FFF_Guatemala.png";
import Image21 from "@cs/public/img/olympiad/partners/FFF_Latvia_.png";
import Image22 from "@cs/public/img/olympiad/partners/FFF_Pakistan__3.png";
import Image23
  from "@cs/public/img/olympiad/partners/FFF_Serbia_white_background.png";
import Image24 from "@cs/public/img/olympiad/partners/FFF_Ukraine_.png";
import Image25 from "@cs/public/img/olympiad/partners/FFF_Uruguay_.png";
import Image26 from "@cs/public/img/olympiad/partners/GirlUpAmoyan.png";
import Image27 from "@cs/public/img/olympiad/partners/GirlUpArzoo.png";
import Image28 from "@cs/public/img/olympiad/partners/GirlUpSNU.png";
import Image29 from "@cs/public/img/olympiad/partners/GirlUpTSRS.png";
import Image30 from "@cs/public/img/olympiad/partners/GirlUp_Aashayein.png";
import Image31 from "@cs/public/img/olympiad/partners/GirlUp_Bani.png";
import Image32 from "@cs/public/img/olympiad/partners/GirlUp_Zariya.png";
import Image33 from "@cs/public/img/olympiad/partners/Girl_Up_Mukti.png";
import Image34 from "@cs/public/img/olympiad/partners/Gray2Green.png";
import Image35 from "@cs/public/img/olympiad/partners/Green_Balkan_.png";
import Image36 from "@cs/public/img/olympiad/partners/Greener_is_Cleaner.png";
import Image37
  from "@cs/public/img/olympiad/partners/IndianYouthClimateNetwork.png";
import Image38 from "@cs/public/img/olympiad/partners/Ksamah20logo.png";
import Image39
  from "@cs/public/img/olympiad/partners/LogoKombi_4GC_KH_RGB_neg.png";
import Image40 from "@cs/public/img/olympiad/partners/NTM.png";
import Image41
  from "@cs/public/img/olympiad/partners/Net_Impact_Delhi_University.png";
import Image42 from "@cs/public/img/olympiad/partners/OG.png";
import Image43 from "@cs/public/img/olympiad/partners/Opportunity_Desk_.png";
import Image44 from "@cs/public/img/olympiad/partners/Scottish_MUN_.png";
import Image45 from "@cs/public/img/olympiad/partners/Spenger.png";
import Image46 from "@cs/public/img/olympiad/partners/Success_Base_Mass_.jpg";
import Image47 from "@cs/public/img/olympiad/partners/Tarang.png";
import Image48
  from "@cs/public/img/olympiad/partners/The_Pearl_Protectors_.png";
import Image49 from "@cs/public/img/olympiad/partners/WESSA_.png";
import Image50 from "@cs/public/img/olympiad/partners/YOH.png";
import Image51 from "@cs/public/img/olympiad/partners/YouthForClimateIndia.png";
import Image52 from "@cs/public/img/olympiad/partners/ekoskola.png";
import Image53 from "@cs/public/img/olympiad/partners/thred_media.png";
import Image54 from "@cs/public/img/olympiad/partners/youth_connect.png";
import Image55 from "@cs/public/img/olympiad/partners/ACE.png";
import Image56 from "@cs/public/img/olympiad/partners/ClimaLab.png";
import Image57 from "@cs/public/img/olympiad/partners/Enactus.png";
import Image58 from "@cs/public/img/olympiad/partners/exp.png";
import Image59 from "@cs/public/img/olympiad/partners/FFFD.png";
import Image60 from "@cs/public/img/olympiad/partners/hnyc.png";
import Image61 from "@cs/public/img/olympiad/partners/KWR.png";
import Image62 from "@cs/public/img/olympiad/partners/Rotary.png";
import Image63 from "@cs/public/img/olympiad/partners/SOSUK.png";
import Image64 from "@cs/public/img/olympiad/partners/YouthStem2030.png";
import Image65 from "@cs/public/img/olympiad/partners/Asian-youth-network.png";
import Image66 from "@cs/public/img/olympiad/partners/Asean-youth-organization.png";
import Image67 from "@cs/public/img/olympiad/partners/AYSDN.png";
import Image68 from "@cs/public/img/olympiad/partners/AtQuest.png";

interface ImageObj {
  alt: string;
  src: StaticImageData
}

const Images:ImageObj[] = [
  { alt: "Bow Seat", src:Image0 },
  { alt: "Building U", src:Image1 },
  { alt: "CCH", src:Image2 },
  { alt: "Climate Smart Agriculture Youth Network", src:Image3 },
  { alt: "Chem Engg Assoll", src:Image4 },
  { alt: "Chloride free fundation", src:Image5 },
  { alt: "Climate for India", src:Image6 },
  { alt: "Climate Operation", src:Image7 },
  { alt: "The Duke of Edinburgh's international award", src:Image8 },
  { alt: "The Duke of Edinburgh's international award (New Zealand)", src:Image9 },
  { alt: "The Duke of Edinburgh's international award (Romania)", src:Image10 },
  { alt: "Earth minutes", src:Image11 },
  { alt: "Eco saviours association", src:Image12 },
  { alt: "Eco network", src:Image13 },
  { alt: "Eco school", src:Image14 },
  { alt: "EmpoderaClima", src:Image15 },
  { alt: "Fridays for future (Nigeria)", src:Image16 },
  { alt: "Fridays for future (Argentina)", src:Image17 },
  { alt: "Fridays for future (Czech Republic)", src:Image18 },
  { alt: "Fridays for future (Greece)", src:Image19 },
  { alt: "Fridays for future (Guatemala)", src:Image20 },
  { alt: "Fridays for future (Latvia)", src:Image21 },
  { alt: "Fridays for future (Pakistan)", src:Image22 },
  { alt: "Fridays for future (Serbia)", src:Image23 },
  { alt: "Fridays for future (Ukraine)", src:Image24 },
  { alt: "Fridays for future (Uruguay)", src:Image25 },
  { alt: "Fridays for future (Delhi)", src:Image59 },
  { alt: "Girl up (Amoyan)", src:Image26 },
  { alt: "Girl up (Arzoo)", src:Image27 },
  { alt: "Girl up (Shiv Nadar University)", src:Image28 },
  { alt: "Girl up (TSRS)", src:Image29 },
  { alt: "Girl up (Aashayein)", src:Image30 },
  { alt: "Girl up (Bani)", src:Image31 },
  { alt: "Girl up (Zariya)", src:Image32 },
  { alt: "Girl up (Mukti)", src:Image33 },
  { alt: "Gray2Green", src:Image34 },
  { alt: "Green Balkan foundation", src:Image35 },
  { alt: "Green is cleaner", src:Image36 },
  { alt: "India Youth Climate Network", src:Image37 },
  { alt: "Ksamah", src:Image38 },
  { alt: "Game changers", src:Image39 },
  { alt: "Nature trust Malta", src:Image40 },
  { alt: "Net impact", src:Image41 },
  { alt: "Oxford Global", src:Image42 },
  { alt: "Opportunity Desk", src:Image43 },
  { alt: "Scottish MUN", src:Image44 },
  { alt: "Spengergasse", src:Image45 },
  { alt: "SuccessBaseMass", src:Image46 },
  { alt: "Tarang", src:Image47 },
  { alt: "The pearl protectors", src:Image48 },
  { alt: "WESSA", src:Image49 },
  { alt: "Youth opportunities hub", src:Image50 },
  { alt: "Youth for climate India", src:Image51 },
  { alt: "Ekoskola", src:Image52 },
  { alt: "Thred meadia", src:Image53 },
  { alt: "Youth connect", src:Image54 },
  { alt: "ACE", src:Image55 },
  { alt: "Clima LAB", src:Image56 },
  { alt: "Enactus", src:Image57 },
  { alt: "Exponenta", src:Image58 },
  { alt: "Human & nature youth club", src:Image60 },
  { alt: "Kazakhstan waste recycling", src:Image61 },
  { alt: "Rotary: Club of Philanthropic Entrepreneurs", src:Image62 },
  { alt: "Students Organising for Sustainability United Kingdom", src:Image63 },
  { alt: "Youth STEM 2030", src:Image64 },
  { alt: "Asian environmental youth network", src:Image65 },
  { alt: "Asean Youth Organization", src:Image66 },
  { alt: "Arab Youth Sustainable Development Network", src:Image67 },
  { alt: "At Quest", src:Image68 }
];

const OlympiadCampaignPartners: FC<{ inverse?: boolean }> = ({
  inverse = true
}) => (
  <section className={styles.cpSection} id={"#partners"}>
    <div className={styles.images}>
      {Images.map((image, index) => (
        <div className={inverse ? styles.image : styles.imageInverse}
          key={index}>
          <Image
            src={image.src}
            alt={image.alt}
          />
        </div>
      ))}
    </div>
  </section>
);

export default OlympiadCampaignPartners;